import React from 'react';
import cn from 'classnames';
import { StaticImageData } from 'next/image';
import Image from '@/Framework/Router/Next/Image';
import SlickSlider from '@/Framework/UI/Molecules/SlickSlider';
import { slickConfigDefault } from '../constants';
import Buttons from './Buttons';
import { IButton } from '../interfaces';

import styles from './ContentOverlay.scss';
import containerStyles from '../ourSolutions.scss';

interface IProps {
  title: string,
  contentText: React.ReactNode,
  icon: TrustedHTML,
  showIcon: boolean,
  textPosition: string,
  images: StaticImageData[],
  isVisible?: boolean,
  buttons?: {
    [key: string]: IButton,
  },
}

const ContentOverlay = ({ textPosition, icon, showIcon, title, contentText, buttons, images }: IProps) => (
  <section className={ containerStyles.container }>
    <div className={ styles.contentBlock }>
      <div
        className={ cn(styles.slider, {
          [styles.blockLeft]: textPosition === 'right',
          [styles.blockRight]: textPosition === 'left',
        }) }
      >
        <div className={ styles.slideContainer }>
          <div className={ styles.slidePlaceholder }>
            <SlickSlider
              data-test={ title }
              className={ styles.slickClass }
              dotsClass={ cn(styles.slickDots, 'slick-dots') }
              { ...slickConfigDefault }
            >
              {
                images.map((image, index) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <div className={ styles.image } key={ index }>
                    <Image src={ image } width={ 588 } height={ 411 } alt={ title } />
                  </div>
                ))
              }
            </SlickSlider>
          </div>
        </div>
      </div>
      <div
        className={ cn(styles.informationBlock, {
          [styles.blockRight]: textPosition === 'right',
          [styles.blockLeft]: textPosition === 'left',
        }) }
      >
        { showIcon && (
          <span className={ styles.iconContainer }>
            <i
              className={ styles.icon }
              dangerouslySetInnerHTML={ { __html: icon } }
            />
          </span>
        ) }
        <div className={ styles.textBlock }>
          <h2>{ title }</h2>
          { contentText }
        </div>
        {
          buttons && (
            <div className={ styles.buttonsBlock }>
              <Buttons
                buttons={ buttons }
              />
            </div>
          )
        }
      </div>
    </div>
  </section>
);

export default ContentOverlay;
